import 'jquery-validation';
import 'npm:jquery-ui/ui/widgets/dialog.js';
import $ from 'jquery';
import cookies from 'js-cookie';

$( () => {

	const cookieName = 'ETNewsLetterSignUp',
	      $formDialog = $( '.newsletter-dialog-form' );
	function getDomainName(hostName) {
        return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1));
	}
	
	function setCookie(cookieValue) {
        var cp=180;      
        var expires=new Date();
        expires.setDate(expires.getDate()+cp);
        cookies.set( cookieName, cookieValue, {
            domain: window.location.hostname,
            secure: true,
            expires,
            path: '/'
        } );        
	}
	
	// validate signup form on keyup and submit
	$("#enewsletterSignup").validate({
		rules: {
			firstname: "required",
			lastname: "required",
			email: {
				required: true,
				email: true
			},
			confirmemail: {
				required: true,
				email: true,
				equalTo: "#email"
			},
			terms: "required"
		},
		async submitHandler(form,event) {
			try {
				event.preventDefault();
				const result = await Promise.resolve( $.ajax( `/fr/services/form/newsletterSignup`, {
					type: 'POST',
					contentType: false,
					data: new FormData( document.getElementById( 'enewsletterSignup' ) as HTMLFormElement ),
					processData: false,
					traditional: false,
					success: function(data) {
						$(".newsletter-dialog-form .thankyou-message").show();
						$('#enewsletterSignup').hide();
						setTimeout(function(){  }, 3000);
					}
				} ) );
				/*			
				if( result.success) {
					$(".newsletter-dialog-form .thankyou-message").show();
					$('#enewsletterSignup').hide();
					setTimeout(function(){  }, 3000);
				}*/			
			} catch( ex ) {
				alert( ex.message );
			}
			return false;
		}
	});

	if( !$formDialog.length ) return;
	var screenWidth, dialogWidth;

    screenWidth = window.screen.width;
    if ( screenWidth < 500 ) {
        dialogWidth = screenWidth * .90;
    } else {
        dialogWidth = 400;
    }


	$(".newsletter-dialog-form").dialog({
		autoOpen: false,
		width: dialogWidth,
		dialogClass: "newsletter-dialog"		
	});
	$('.newsletter-dialog').css({position:"fixed"});
	$(".newsletter-dialog-form .thankyou-message").hide();
	
    if(! cookies.get( cookieName )) {
        setTimeout(function() {
			$(".newsletter-dialog-form").dialog("open");
			setCookie("ViewedSignupForm");
		}, 5000);
    } else {
		$(".newsletter-dialog-form").hide();
	}
		
});

